module.exports = __webpack_public_path__ + "static/media/tired.8050052f.svg";